import type { FloorFixture } from '../types';

export const defaultFloorFixtures: FloorFixture[] = [
  {
    id: 'entrance',
    type: 'entrance',
    label: 'Entrance',
    x: 50,
    y: 4,
    width: 30,
    height: 5,
    rotation: 0,
  },
  {
    id: 'bar',
    type: 'bar',
    label: 'Bar',
    x: 92,
    y: 40,
    width: 8,
    height: 60,
    rotation: 0,
  },
  {
    id: 'patio',
    type: 'patio',
    label: 'Patio',
    x: 80,
    y: 85,
    width: 30,
    height: 25,
    rotation: 0,
  },
];

